import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import React from "react";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import moment from "moment";
export default function TranferFormRow({
  item,
  index,
  handleTransferFrom,
  transferValidation,
  disabled,
  promoterOptions,
  removeTransferFromData,
  currentDate,
}) {
  const ajustFormRow = React.useMemo(
    () => (
      <Stack key={index} sx={{ my: 2 }} direction={"row"} spacing={2}>
        <Stack
          direction={"row"}
          justifyContent="space-between"
          alignItems={"flex-start"}
          sx={{ flex: 7 }}
          spacing={1}
        >
          <DatePicker
            sx={{ flex: 1 }}
            disabled={disabled}
            id="date"
            name="date"
            label="日期"
            value={item.date}
            minDate={moment(currentDate).startOf("month").format("YYYY-MM-DD")}
            maxDate={moment(currentDate).endOf("month").format("YYYY-MM-DD")}
            onChange={(value) => {
              handleTransferFrom(
                index,
                "date",
                moment(value).format("YYYY-MM-DD")
              );
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                error={!!transferValidation[index]?.dateErr}
                helperText={transferValidation[index]?.dateErr}
              />
            )}
          ></DatePicker>
          <Autocomplete
            sx={{ flex: 1 }}
            required
            disabled={disabled}
            id="combo-box-demo"
            options={promoterOptions}
            value={item.transferUser}
            onChange={async (e, newValue) => {
              handleTransferFrom(index, "transferUser", newValue);
            }}
            label="員工"
            renderInput={(params) => <TextField {...params} label="員工" />}
          />
          <TextField
            disabled={true}
            value={item.rosterString}
            id="outlined-basic"
            label="更表"
            variant="outlined"
          />
          <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
            <TextField
              disabled={disabled}
              error={!!transferValidation[index]?.transferAmountErr}
              helperText={transferValidation[index]?.transferAmountErr}
              sx={{ maxWidth: 380, minWidth: 100 }}
              value={item.transferAmount}
              type="number"
              id="outlined-basic"
              label="調整金額"
              variant="outlined"
              onChange={(event) =>
                handleTransferFrom(index, "transferAmount", event.target.value)
              }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
          </Box>
        </Stack>
        {!disabled && (
          <Stack
            direction={"row"}
            justifyContent="space-between"
            alignItems={"flex-start"}
            sx={{ flex: 1 }}
          >
            <IconButton
              color="error"
              onClick={() => removeTransferFromData(index)}
            >
              <DeleteForeverIcon></DeleteForeverIcon>
            </IconButton>
          </Stack>
        )}
      </Stack>
    ),
    [item, index, removeTransferFromData]
  );
  return ajustFormRow;
}
